import React, { Fragment } from 'react';
import ApprovalTypeListBrowser from './ApprovalTypeListBrowser';
import PropTypes from 'prop-types';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import HeaderLinks from '../edit/header/ApprovalTypeListHeaderLinks';
import Portal from 'utils/portal/Portal';
import { withAreaGetter } from 'providers/AreasConsumers';
import { areas } from 'constants/areas';
import useHistoryWithContext from '../../../../components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_APPROVAL_TYPES } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const onAdd = () => {
    historyContext.push(`/approvalTypes/new`);
  };

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_APPROVAL_TYPES} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_APPROVAL_TYPES}>
        <ApprovalTypeListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
